// extracted by mini-css-extract-plugin
export default {"LawCellNotification":"LawCellNotification_LawCellNotification__aPcOg"};